<template>
  <section v-if="result" class="main-slider">
    <DefSlider :settings="settings" :nav="true" :pagination="true" :priority="true">
      <div
        v-for="(item, i) in result.items"
        class="swiper-slide"
        :data-swiper-autoplay="+item.timeout * 1000 || 5000"
      >
        <a :href="item.link || item.detailPage" class="main-slider__link">
          <DefBannerMedia :result="item" :priority="i === 0" />
        </a>
      </div>
    </DefSlider>
  </section>
</template>

<script>
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import useScreenWidth from '@use/useScreenWidth';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import DefBannerMedia from '@components/Def/DefBanner/DefBannerMedia.vue';

export default {
  name: 'MainSlider',
  components: {
    DefBannerMedia,
    DefSlider,
  },
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      settings: {
        // effect: 'fade',
        modules: [Autoplay, Navigation, Pagination],
        autoplay: true,
      },
      screenWidth: useScreenWidth(),
    };
  },
};
</script>

<style lang="scss" scoped>
.main-slider {
  margin-top: 1px;
  &__link {
    display: block;
  }
  :deep(.def-slider) {
    position: relative;
  }
  :deep(.def-slider__default-button) {
    background-color: var(--background-black);
    svg {
      fill: #fff;
    }
  }
  :deep(.def-picture__image) {
    width: 100%;
  }
  :deep(.def-slider__container) {
    margin-bottom: 0;
  }
  :deep(.def-slider .swiper-pagination) {
    position: absolute;
    bottom: 24px;
  }
  .swiper-slide {
    display: block;
    height: unset;
    margin-top: auto;
    margin-bottom: auto;
  }
}
</style>
